import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/SVG/1999/native\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-star\"><path d=\"M557.25312 806.5024a56.32 56.32 0 0 1-73.1648 0L258.56 596.1728l-76.8-114.0736 30.72-20.48L512 692.224l297.984-230.6048 30.72 20.48-69.12 102.4L557.25312 806.5024z\" p-id=\"11002\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol